import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { CurrentLang, MagstimExportableTableBase } from "common";

class MagstimRmtLevelsTable extends MagstimExportableTableBase {

    componentDidMount() {

        this.setState({
            exportFileName: this.props.exportFileName,
            apiEndPoint: this.props.apiEndPoint
        }, () => {
            this.loadDataFromAPI();
        });
    }

    getTableData = (filteredData) => {

        var tableData = [];

        // Iterate over the selected filter
        for (var item in filteredData) {
            if (item !== null && item !== undefined) {

                // Grab the top level summary item
                var summaryItem = filteredData[item];

                if (summaryItem !== undefined && summaryItem !== null) {

                    if(summaryItem.Summary.PatientCount > 0){
                        summaryItem.Summary.AverageMTLevel = 0.0;
                        if (summaryItem.Summary.MotorThresholds > 0) {
                            summaryItem.Summary.AverageMTLevel = (summaryItem.Summary.SumMTLevel / summaryItem.Summary.MotorThresholds).toFixed(1);
                        } else {
                            summaryItem.Summary.AverageMTLevel = CurrentLang().no_data;
                        }
    
                        if (item === '') {
                           summaryItem.Summary[this.props.summaryProperty] = CurrentLang().no_data;
                        }else{
                            summaryItem.Summary[this.props.summaryProperty] =  item;
                        }
    
                        tableData.push(summaryItem.Summary);
                    }        
                }
            }
        }

        return tableData;
    }

    getTable = () => {
        return React.createElement(this.props.tableClassType, { ref:this._table,  div_name:this.props.summaryProperty}, null)
    }

}

MagstimRmtLevelsTable.propTypes = {
    exportFileName: PropTypes.string,
    apiEndPoint:PropTypes.string,
    averageOnGuidProperty:PropTypes.string,
    tableClassType:PropTypes.elementType
};

MagstimRmtLevelsTable.defaultProps = {
    exportFileName:'',
    apiEndPoint:'',
    summaryProperty:"",
    tableClassType:undefined
};

export default withRouter(MagstimRmtLevelsTable) 